import { AppNode } from "@features/builder/graph/types"
import {
  expandedGroupMinHeight,
  expandedGroupMinWidth,
  groupPadding,
  groupTitleHeight,
} from "@features/builder/helpers/nodes"
import { InternalNode, ResizeParamsWithDirection } from "@xyflow/react"

export const getRect = {
  resizedNodeAbs(internalResizedNode: InternalNode<AppNode> | undefined) {
    let x = 0
    if (internalResizedNode?.internals.positionAbsolute !== undefined)
      x = internalResizedNode.internals.positionAbsolute.x

    let y = 0
    if (internalResizedNode?.internals.positionAbsolute !== undefined)
      y = internalResizedNode.internals.positionAbsolute.y

    let width = expandedGroupMinWidth
    if (internalResizedNode?.width !== undefined) width = internalResizedNode.width

    let height = expandedGroupMinHeight
    if (internalResizedNode?.height !== undefined) height = internalResizedNode.height

    return { x, y, width, height }
  },

  groupAbs(
    resizedNodeAbs: ReturnType<typeof this.resizedNodeAbs>,
    resizedNode: ResizeParamsWithDirection,
  ) {
    return {
      left: resizedNodeAbs.x + groupPadding,
      right: resizedNodeAbs.x + resizedNode.width - groupPadding,
      top: resizedNodeAbs.y + groupPadding + groupTitleHeight,
      bottom: resizedNodeAbs.y + resizedNode.height - groupPadding,
    }
  },

  child(internalChildNode: InternalNode<AppNode> | undefined, childNode: AppNode | undefined) {
    let x = 0
    if (internalChildNode?.internals.positionAbsolute !== undefined)
      x = internalChildNode.internals.positionAbsolute.x

    let y = 0
    if (internalChildNode?.internals.positionAbsolute !== undefined)
      y = internalChildNode.internals.positionAbsolute.y

    let width = expandedGroupMinWidth
    if (childNode?.measured?.width !== undefined) width = childNode.measured.width

    let height = expandedGroupMinHeight
    if (childNode?.measured?.height !== undefined) height = childNode.measured.height

    return { x, y, width, height }
  },

  childAbs(child: ReturnType<typeof this.child>) {
    return {
      left: child.x,
      right: child.x + child.width,
      top: child.y,
      bottom: child.y + child.height,
    }
  },
} as const
